import * as client from './baseClient';

export const getInjuriesByBranch = (branchId) =>
  client.get(`/api/injuries/branch/${branchId}`);

export const getInjuriesByCompany = (companyId) =>
  client.get(`/api/injuries/company/${companyId}`);

export const createAccident = (accident, loggedInUserId) =>
  client.post('/api/injuries', accident, undefined, loggedInUserId);

export const editAccident = (accident, loggedInUserId) =>
  client.put(
    `/api/injuries/${accident.id}`,
    accident,
    undefined,
    loggedInUserId
  );

export const deleteAccident = (accidentId, loggedInUserId) =>
  client._delete(
    `/api/injuries/${accidentId}`,
    undefined,
    undefined,
    loggedInUserId
  );
